import produce from 'immer'
import { includes, get } from 'lodash'
import {
  SET_CLIENT_FETCH_ID,
  FETCH_CLIENT_REQUEST,
  FETCH_CLIENT_SUCCESS,
  FETCH_CLIENT_FAILURE,
  FETCH_CLIENT_HOMES_REQUEST,
  FETCH_CLIENT_HOMES_SUCCESS,
  FETCH_CLIENT_HOMES_FAILURE,
  SAVE_CLIENT_ANSWER_SUCCESS,
  SAVE_CLIENT_ANSWER_FAILURE,
  SAVE_CLIENT_DATA_REQUEST,
  SAVE_CLIENT_DATA_SUCCESS,
  SAVE_CLIENT_DATA_FAILURE
} from 'src/actions/actionTypes'
import { clientState } from 'src/factories/client'
import {
  BUYER_ONBOARDED,
  ORDERED_QUESTIONS,
  QUESTIONS_TO_STATE
} from 'src/constants/client/onboarding'

export const initialState = clientState()

export default (state = initialState, { id, type, data, error, saveRequest }) =>
  produce(state, draft => {
    const updateAnswer = ({ id, question, response }) => {
      const answer = draft.data.clientAnswers.find(({ id: i }) => i === id)

      if (answer) {
        Object.assign(answer, { question, response })
      } else {
        draft.data.clientAnswers.push({
          id,
          question,
          response
        })
      }

      const pickedKeys = draft.data.clientAnswers.map(({ question: q }) => q)

      const firstEmpty = ORDERED_QUESTIONS.find(q => !includes(pickedKeys, q))

      draft.data.onboardingState =
        QUESTIONS_TO_STATE[firstEmpty] || BUYER_ONBOARDED
    }

    switch (type) {
      case SET_CLIENT_FETCH_ID:
        if (id !== draft.data.id) {
          Object.assign(draft, initialState)
        }
        draft.fetchId = id
        break

      case FETCH_CLIENT_REQUEST:
        draft.hasRequestedClient = true
        draft.error = null
        break

      case FETCH_CLIENT_HOMES_REQUEST:
        draft.hasRequestedHomes = true
        break

      case FETCH_CLIENT_SUCCESS:
        draft.loadingData = false
        if (data.id === draft.fetchId) {
          const combindedData = Object.assign({}, draft.data, data)
          draft.data = combindedData
        }
        break

      case FETCH_CLIENT_HOMES_SUCCESS:
        draft.loadingHomes = false
        draft.data.homes = data
        break

      case FETCH_CLIENT_FAILURE:
        draft.loadingData = false
        draft.error = error
        if (get(error, 'response.status') === 404) {
          Object.assign(draft, initialState)
          draft.fetchId = 'not-found'
        }
        break

      case FETCH_CLIENT_HOMES_FAILURE:
        draft.loadingHomes = false
        draft.error = error
        break

      case SAVE_CLIENT_ANSWER_SUCCESS:
        updateAnswer(data)
        break

      case SAVE_CLIENT_ANSWER_FAILURE:
        draft.error = error
        break

      case SAVE_CLIENT_DATA_REQUEST:
        draft.saveRequest = saveRequest
        break

      case SAVE_CLIENT_DATA_SUCCESS:
        if (data.id === draft.fetchId) {
          const combindedData = Object.assign({}, draft.data, data)
          draft.data = combindedData
        }
        break

      case SAVE_CLIENT_DATA_FAILURE:
        draft.saveError = error
        break

      default:
        break
    }
  })
